import { PageProps } from '../components/Page';
import User from '../models/User';

export default function requireUser(props: PageProps): User {
  if (!props.user) {
    throw new Error('No user found');
  }
  return props.user;
}
